export const SEARCH_CODE = {
  COLLECTION: 'collection_search', // collection
  CART_MAKEUP: 'cart_add_items' // 购物车凑单
}